import { ClientInferResponseBody } from "@ts-rest/core";

import { api, contract } from "#app/http/api";
import { QuoteRequestStatusType } from "shared";

export type AllQuoteRequestDto = ClientInferResponseBody<
  typeof contract.quoteRequests.findAll,
  200
>[number];

export const fetchQuoteRequests = async (
  page: number,
  filters?: {
    status?: QuoteRequestStatusType | undefined;
    ownerId?: string | undefined;
    isFavorite?: boolean | undefined;
  },
): Promise<AllQuoteRequestDto[]> => {
  const response = await api.quoteRequests.findAll.query({
    query: {
      page,
      status: filters?.status,
      ownerId: filters?.ownerId,
      isFavorite: filters?.isFavorite,
    },
  });

  if (response.status === 200) {
    return response.body;
  }

  return [];
};
